enum LifeExpectancyBasis {
    Health = 0,
    Survival = 1
}

export default LifeExpectancyBasis;
